/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Fix Add to Cart — AJAX add and open cart drawer sidebar
  // Uses capture phase to intercept before theme's handler
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    // Only handle if cart type is drawer
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'drawer') return;

    // Skip if button is disabled or variant is sold out
    if (btn.disabled || btn.hasAttribute('disabled')) return;

    var formWrapper = btn.closest('[data-product-form]')?.closest('.product__form__holder');
    if (formWrapper && formWrapper.classList.contains('variant--soldout')) {
      // Let the theme handle notification popup for sold-out items
      return;
    }

    // Prevent default form submission AND stop theme's handler from also firing
    e.preventDefault();
    e.stopImmediatePropagation();

    // Show loading state
    btn.classList.add('is-loading');
    btn.setAttribute('disabled', 'disabled');

    // Build clean form data, excluding noscript duplicates
    var formData = new FormData();
    var elements = Array.from(form.elements);

    elements.forEach(function(el) {
      // Skip elements inside <noscript> (they create duplicate name="id" with empty value)
      if (el.closest('noscript')) return;
      // Skip disabled elements and buttons
      if (el.disabled || el.type === 'submit' || el.type === 'button') return;
      // Skip unchecked radio/checkboxes
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;

      var key = el.name;
      if (!key) return;

      formData.set(key, el.value);
    });

    // Ensure variant ID is set from the hidden input
    var variantInput = form.querySelector('input[name="id"][data-product-select]');
    if (variantInput && variantInput.value) {
      formData.set('id', variantInput.value);
    }

    // Ensure quantity is set
    if (!formData.get('quantity')) {
      formData.set('quantity', '1');
    }

    fetch(window.theme.routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript',
      },
      body: formData,
    })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data.status) {
          // Error from Shopify (variant unavailable, etc.)
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');

          var errContainer = form.querySelector('[data-cart-errors-container]');
          if (errContainer) {
            errContainer.textContent = data.description || data.message || 'Could not add to cart';
          }
          return;
        }

        // Successfully added — dispatch event for other theme features
        document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));

        // Update cart drawer and open it
        loadAndOpenCartDrawer(btn);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
      });
  }, true); // <-- capture phase: fires before theme's bubbling handler

  function loadAndOpenCartDrawer(submitBtn) {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) {
      window.location = window.theme.routes.cart_url || '/cart';
      return;
    }

    var cartDrawerTemplate = document.querySelector('[data-cart-drawer-template]');
    if (cartDrawerTemplate && !cartDrawer.querySelector('[data-cart-drawer-body]')) {
      cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
    }

    // Safety timeout — open drawer even if refresh fails
    var opened = false;
    var safetyTimer = setTimeout(function() {
      if (!opened) {
        opened = true;
        openDrawer(cartDrawer, submitBtn);
      }
    }, 3000);

    // Use shared refresh, then open drawer
    refreshCartDrawer(function() {
      if (!opened) {
        opened = true;
        clearTimeout(safetyTimer);
        openDrawer(cartDrawer, submitBtn);
      }
    });
  }

  function openDrawer(cartDrawer, submitBtn) {
    if (!cartDrawer) return;

    // Reset button state
    if (submitBtn) {
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('disabled');
    }

    // Open cart drawer sidebar
    document.body.classList.add('js-drawer-open-cart');
    cartDrawer.classList.add('is-open');
    cartDrawer.classList.remove('cv-h');

    // Lock body scroll
    document.documentElement.style.overflow = 'hidden';

    // Dispatch theme events so other components stay in sync
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: cartDrawer }));

    var cartDrawerBody = cartDrawer.querySelector('[data-cart-drawer-body]');
    if (cartDrawerBody) {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: cartDrawerBody }));
    }

    // Set aria-expanded on cart toggle buttons
    var toggleBtns = document.querySelectorAll('[data-cart-drawer-toggle]');
    toggleBtns.forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    // Animate cart items in
    var aosItems = cartDrawer.querySelectorAll('[data-aos]');
    aosItems.forEach(function(item) {
      requestAnimationFrame(function() { item.classList.add('aos-animate'); });
    });

    // Bind close button
    var closeBtn = cartDrawer.querySelector('[data-cart-drawer-toggle]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer(cartDrawer);
      });
    }

    // Close on overlay/outside click
    cartDrawer.addEventListener('click', function(e) {
      if (e.target === cartDrawer) {
        closeDrawer(cartDrawer);
      }
    });

    // Dispatch cart added event
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
  }

  function closeDrawer(cartDrawer) {
    if (!cartDrawer) return;

    document.body.classList.remove('js-drawer-open-cart');
    cartDrawer.classList.remove('is-open');

    document.documentElement.style.overflow = '';

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));

    var toggleBtns = document.querySelectorAll('[data-cart-drawer-toggle]');
    toggleBtns.forEach(function(btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  // Kept for backward compat — now just triggers a lightweight cart count update
  function updateCartCount() {
    fetch((window.theme.routes.cart_url || '/cart') + '.js', {
      headers: { 'Accept': 'application/json' },
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
        document.querySelectorAll('.cart__toggle').forEach(function(toggle) {
          toggle.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
        });
      })
      .catch(function() {});
  }

  // Format paise to rupee string (e.g. 249900 -> "₹2,499.00")
  function formatMoney(paise) {
    var rupees = (paise / 100).toFixed(2);
    var parts = rupees.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '₹' + parts[0] + '.' + parts[1];
  }

  // Shared function: refresh all cart drawer contents (line items, freeship bar, order summary, counts)
  function refreshCartDrawer(callback) {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;

    var sectionUrl = (window.theme.routes.cart_url || '/cart') + '?section_id=api-cart-items&t=' + Date.now();

    // Fetch both section HTML and cart.js in parallel
    Promise.all([
      fetch(sectionUrl).then(function(r) { return r.text(); }),
      fetch((window.theme.routes.cart_url || '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); })
    ]).then(function(results) {
      var html = results[0];
      var cart = results[1];

      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var apiContent = tmp.querySelector('[data-api-content]');

      // --- Update Line Items ---
      if (apiContent) {
        var lineItems = apiContent.querySelector('[data-api-line-items]');
        var priceData = apiContent.querySelector('[data-api-cart-price]');
        var itemsHolder = cartDrawer.querySelector('[data-items-holder]');
        var priceHolder = cartDrawer.querySelector('[data-cart-price-holder]');

        if (itemsHolder && lineItems) {
          itemsHolder.innerHTML = lineItems.innerHTML;
          itemsHolder.classList.remove('hidden');
        }
        if (priceHolder && priceData) {
          priceHolder.innerHTML = priceData.innerHTML;
        }
      }

      // --- Toggle empty/filled state ---
      var emptyMessage = cartDrawer.querySelector('[data-empty-message]');
      var emptyMessageBottom = cartDrawer.querySelector('[data-empty-message-bottom]');
      var cartForm = cartDrawer.querySelector('[data-cart-form]');
      var orderSummary = cartDrawer.querySelector('[data-order-summary]');
      var cartNotesHolder = cartDrawer.querySelector('[data-cart-notes-holder]');
      var itemsHolderEl = cartDrawer.querySelector('[data-items-holder]');

      if (cart.item_count === 0) {
        if (itemsHolderEl) itemsHolderEl.classList.add('hidden');
        if (emptyMessage) emptyMessage.classList.remove('hidden');
        if (emptyMessageBottom) emptyMessageBottom.classList.remove('hidden');
        if (cartForm) cartForm.classList.add('hidden');
        if (orderSummary) orderSummary.classList.add('hidden');
        if (cartNotesHolder) cartNotesHolder.classList.add('hidden');
      } else {
        if (emptyMessage) emptyMessage.classList.add('hidden');
        if (emptyMessageBottom) emptyMessageBottom.classList.add('hidden');
        if (cartForm) cartForm.classList.remove('hidden');
        if (orderSummary) orderSummary.classList.remove('hidden');
        if (cartNotesHolder) cartNotesHolder.classList.remove('hidden');
      }

      // --- Update item qty badge in drawer header ---
      var qtyBadge = cartDrawer.querySelector('[data-cart-items-qty]');
      if (qtyBadge) {
        qtyBadge.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
        qtyBadge.classList.toggle('hidden', cart.item_count === 0);
      }

      // --- Update Free Shipping Progress Bar ---
      var FREE_SHIP_THRESHOLD = 599000;
      var apiFreeshipData = tmp.querySelector('[data-api-freeship-bar]');
      var freeshipBar = cartDrawer.querySelector('[data-freeship-bar]');

      if (freeshipBar && apiFreeshipData) {
        var fsRemainingEl = apiFreeshipData.querySelector('[data-fs-remaining]');
        var fsProgressEl = apiFreeshipData.querySelector('[data-fs-progress]');
        var fsRemaining = fsRemainingEl ? parseInt(fsRemainingEl.getAttribute('data-fs-remaining'), 10) : 0;
        var fsProgress = fsProgressEl ? parseInt(fsProgressEl.getAttribute('data-fs-progress'), 10) : 0;
        var fsRemainingFormatted = fsRemainingEl ? fsRemainingEl.textContent.trim() : '';

        var freeshipText = freeshipBar.querySelector('.cart-drawer__freeship-text');
        var freeshipFill = freeshipBar.querySelector('.cart-drawer__freeship-fill');
        var freeshipTruck = freeshipBar.querySelector('.cart-drawer__freeship-truck');

        if (freeshipText) {
          if (fsRemaining === 0) {
            freeshipText.innerHTML = '🎉 Congrats, you unlocked Free Shipping!';
          } else {
            freeshipText.innerHTML = '<p>Unlock your Gift</p><p>You are <strong>' + fsRemainingFormatted + '</strong> away from Free Shipping</p>';
          }
        }
        if (freeshipFill) freeshipFill.style.width = fsProgress + '%';
        if (freeshipTruck) {
          freeshipTruck.style.left = fsProgress + '%';
          freeshipTruck.textContent = fsRemaining === 0 ? '🎊' : '🚚';
        }
      }

      // --- Update Order Summary ---
      try {
        var apiOsData = tmp.querySelector('[data-api-order-summary]');
        if (orderSummary && apiOsData && cart.item_count > 0) {
          var compareTotalEl = apiOsData.querySelector('[data-os-compare-total]');
          var salePriceEl = apiOsData.querySelector('[data-os-sale-price]');
          var finalTotalEl = apiOsData.querySelector('[data-os-final-total]');
          var additionalDiscountEl = apiOsData.querySelector('[data-os-additional-discount]');
          var totalSavingsEl = apiOsData.querySelector('[data-os-total-savings]');

          if (compareTotalEl && salePriceEl && finalTotalEl && additionalDiscountEl && totalSavingsEl) {
            var compareTotal = parseInt(compareTotalEl.getAttribute('data-os-compare-total'), 10) || 0;
            var salePrice = parseInt(salePriceEl.getAttribute('data-os-sale-price'), 10) || 0;
            var finalTotal = parseInt(finalTotalEl.getAttribute('data-os-final-total'), 10) || 0;
            var additionalDiscount = parseInt(additionalDiscountEl.getAttribute('data-os-additional-discount'), 10) || 0;
            var totalSavings = parseInt(totalSavingsEl.getAttribute('data-os-total-savings'), 10) || 0;

            var compareTotalFormatted = compareTotalEl.textContent.trim();
            var salePriceFormatted = salePriceEl.textContent.trim();
            var finalTotalFormatted = finalTotalEl.textContent.trim();
            var additionalDiscountFormatted = additionalDiscountEl.textContent.trim();
            var totalSavingsFormatted = totalSavingsEl.textContent.trim();

            var discountTitles = [];
            apiOsData.querySelectorAll('[data-os-discount-title]').forEach(function(el) { discountTitles.push(el.textContent.trim()); });

            var osHtml = '';
            osHtml += '<div class="order-summary__row"><span>Original Price</span><span class="order-summary__strike">';
            osHtml += (compareTotal > finalTotal) ? '<s>' + compareTotalFormatted + '</s>' : compareTotalFormatted;
            osHtml += '</span></div>';
            osHtml += '<div class="order-summary__row"><span>Discounted Price</span><span>' + salePriceFormatted + '</span></div>';
            osHtml += '<div class="order-summary__row"><span>Shipping</span>';
            osHtml += (finalTotal >= FREE_SHIP_THRESHOLD) ? '<span class="order-summary__free">FREE</span>' : '<span>(calculated at checkout)</span>';
            osHtml += '</div>';
            if (additionalDiscount > 0) {
              osHtml += '<div class="order-summary__row order-summary__row--extra-discount"><span>Additional Discount:</span><span class="order-summary__extra-discount-amount">- ' + additionalDiscountFormatted;
              discountTitles.forEach(function(t) { osHtml += ' (' + t + ')'; });
              osHtml += '</span></div>';
            }
            if (totalSavings > 0) {
              osHtml += '<div class="order-summary__row order-summary__row--savings"><span>You Save</span><span class="order-summary__savings-amount">- ' + totalSavingsFormatted + '</span></div>';
            }
            osHtml += '<div class="order-summary__divider"></div>';
            osHtml += '<div class="order-summary__row order-summary__row--final"><span>Final Price</span><span>' + finalTotalFormatted + '</span></div>';

            var osBox = orderSummary.querySelector('.order-summary__box');
            if (osBox) osBox.innerHTML = osHtml;
          }
        }
      } catch(osErr) {
        console.error('Order summary update error:', osErr);
      }

      // --- Update header cart count badges ---
      var cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(function(el) { el.textContent = cart.item_count; });
      var cartToggles = document.querySelectorAll('.cart__toggle');
      cartToggles.forEach(function(toggle) {
        toggle.classList.toggle('cart__toggle--has-items', cart.item_count > 0);
      });

      if (typeof callback === 'function') callback();
    }).catch(function(err) {
      console.error('Cart drawer refresh error:', err);
      if (typeof callback === 'function') callback();
    });
  }

  // Handle quantity +/- buttons inside cart drawer
  document.addEventListener('click', function(e) {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer || !cartDrawer.contains(e.target)) return;

    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');

    if (!minusBtn && !plusBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var holder = (minusBtn || plusBtn).closest('[data-quantity-holder]');
    if (!holder) return;

    var input = holder.querySelector('[data-quantity-field]');
    if (!input) return;

    var currentQty = parseInt(input.value, 10) || 1;
    var newQty = minusBtn ? Math.max(0, currentQty - 1) : currentQty + 1;
    var lineKey = input.getAttribute('data-id');

    input.value = newQty;

    fetch((window.theme.routes.cart_change_url || '/cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: newQty }),
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        refreshCartDrawer();
      });
  }, true);

  // Handle remove button inside cart drawer
  document.addEventListener('click', function(e) {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer || !cartDrawer.contains(e.target)) return;

    var removeBtn = e.target.closest('[data-item-remove]');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var lineKey = removeBtn.getAttribute('data-id');

    fetch((window.theme.routes.cart_change_url || '/cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        refreshCartDrawer();
      });
  }, true);

  // Handle header cart icon click — open cart drawer
  document.addEventListener('click', function(e) {
    var toggleBtn = e.target.closest('[data-cart-drawer-toggle]');
    if (!toggleBtn) return;

    // Don't handle if inside an already-open cart drawer (that's a close action)
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (cartDrawer && cartDrawer.contains(toggleBtn)) return;

    // Only handle if cart type is drawer
    if (!window.theme || !window.theme.settings || window.theme.settings.cartType !== 'drawer') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!cartDrawer) {
      window.location = window.theme.routes.cart_url || '/cart';
      return;
    }

    // Load template if not loaded yet
    var cartDrawerTemplate = document.querySelector('[data-cart-drawer-template]');
    if (cartDrawerTemplate && !cartDrawer.querySelector('[data-cart-drawer-body]')) {
      cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
    }

    // Refresh cart contents and open drawer
    refreshCartDrawer(function() {
      openDrawer(cartDrawer, null);
    });
  }, true);
})();
